import React from "react";
import { AddMasterDataProps } from "./Index";
import { Title } from "../../../../../stories/Title/Title";
import InputHoc from "../../../../common/Input/Index";
import { Keys } from "../../../../../utils/Enum.keys";
import { Operation } from "../../../../../utils/Enum.types";

const Add = ({
  formData,
  handleValueChange,
  meta,
  operation,
}: AddMasterDataProps) => {
  const submitBtn = document.getElementsByClassName("submit");
  return (
    <>
      <div className="master-data__add">
        <Title variant="subtitle1">{`${
          operation === Operation.CREATE ? "Add" : "Update"
        } Category`}</Title>
        <div className="master-data__add--form">
          <InputHoc
            LabelName={`Category Description`}
            values={formData.groupName}
            name="groupName"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleValueChange(e, meta)
            }
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key === Keys.ENTER) {
                submitBtn.length && (submitBtn[0] as HTMLButtonElement).focus();
              }
            }}
            autoFocus
            required
          />
        </div>
      </div>
    </>
  );
};

export default Add;
